import { FC } from 'react';
import './Footer.scss';

const Footer: FC = (): JSX.Element => {
  return (
    <div className="container footer">
      <div className="footer-text-1">
        <p>{_t('© 2023 Cables. All Rights Reserved.', 'FOOTER.RESERVED')}</p>
      </div>

      <div className="footer-text-3">
        <a href="https://www.cables.finance/terms-of-use" target="_blank">
          {_t('Terms of Use', 'FOOTER.TERMS')}
        </a>
      </div>

      <div className="footer-text-2">
        <a href="https://support.cables.finance/portal/en/signin" target="_blank">
          {_t('Contact Support', 'FOOTER.SUPPORT')}
        </a>
      </div>

      <div className="footer-text-4">
        <a href="https://www.cables.finance/privacy-policy" target="_blank">
          {_t('Privacy Policy', 'FOOTER.PRIVACY')}
        </a>
      </div>

      <div className="footer-text-3-1">
        <a href="https://cables-finance-1.gitbook.io/cables.finance/" target="_blank">
          {_t('Documentation', 'FOOTER.DOCUMENTATION')}
        </a>
      </div>
    </div>
  );
};

export default Footer;
